import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import useLogger from "../../util/Logger";
import "./PropertySearchResult.css";

function PropertySearchResult({ result, type }) {
  const logger = useLogger();
  const navigate = useNavigate();

  const propertyId = result.PropertyID;

  const clickSearchResult = () => {
    logger.debug(
      "PropertySearchResult.clickSearchResult",
      `Navigating to property '${propertyId}'`
    );
    if (["Address", "Postcode"].includes(type))
      navigate(`/property/${propertyId}`);
    if (type === "WorkOrder")
      navigate(`/property/${propertyId}/workorder/${result.WorkOrderID}`);
    if (type === "WorkItem")
      navigate(`/property/${propertyId}/workorder/${result.WorkOrderID}`);
  };

  if (result !== undefined && result != null) {
    return (
      <tr className="property-search-result" onClick={clickSearchResult}>
        <td>{result.FullAddress}</td>
        <td>{result.SiteName}</td>
        <td>{result.Postcode}</td>
        {["WorkOrder", "WorkItem"].includes(type) && (
          <td>{result.WorkOrderID}</td>
        )}
        {type === "WorkItem" && <td>{result.WorkItemReference}</td>}
      </tr>
    );
  }

  return null;
}

PropertySearchResult.propTypes = {
  result: PropTypes.shape({
    PropertyID: PropTypes.string,
    FullAddress: PropTypes.string,
    SiteName: PropTypes.string,
    Postcode: PropTypes.string,
    WorkOrderID: PropTypes.string,
    WorkItemReference: PropTypes.string,
    WorkItemID: PropTypes.string,
  }).isRequired,
  type: PropTypes.string.isRequired,
};

export default PropertySearchResult;
